export const auth = {
    authModalTitle: 'Anmeldung ist erforderlich',
    authModalDescription:
        'Anmeldung ist erforderlich um diese Aktion fortzusetzten. Bitte wählen sie aus:',
    loginHeading: 'Anmelden',
    createAccount: 'Neues Konto erstellen',
    registrationHeading: 'Anmelden',
    pleaseFillAll: 'bitte füllen sie alle Felder aus',
    inputWithNameIsRequired: ['Das Feld', 'ist zwingend erforderlich!'],
    orUse: 'order verwenden',
    register: 'registrieren',
    login: 'anmelden',
    nameLabel: 'Name',
    firstName: 'Vorname',
    lastName: 'Nachname',
    editProfile: 'Profil bearbeiten',
    changePassword: 'Passwort ändern',
    emailLabel: 'Email',
    passwordLabel: 'Passwort',
    newPasswordLabel: 'Neues Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    iHaveRead: [
        'Ich habe die AGB und Datenschutzerklärung',
        'gelesen und nehme sie zur Kenntnis',
        'um die Registrierung abzuschliessen'
    ],

    passPolicyLength: 'Ungültiges Passwort: minimale Länge 8.',
    passPolicyUpperCase: 'Ungültiges Passwort: mindestens ein Großbuchstabe.',
    passPolicyNumber: 'Ungültiges Passwort: mindestens eine Ziffer.',
    passPolicyLowerCase: 'Ungültiges Passwort: mindestens ein Kleinbuchstabe.',
    passAndConfirmDontMatch: 'Passwort und Bestätigung sind nicht identisch.',

    dontHaveAnAccount: 'Haben sie noch kein Konto?',
    alreadyHaveAnAccount: 'Haben sie schon ein Konto?'
};
